import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import Button from "../../../Button";
import { withScrollReset } from "../../hoc/withScrollReset";

const from = (page, pageSize) => (page - 1) * pageSize + 1;

const to = (page, pageSize, totalCount) => {
  const toCandidate = page * pageSize;
  return toCandidate <= totalCount ? toCandidate : totalCount;
};

const DndPaginator = ({
  page,
  pageSize,
  totalCount,
  onPrevious,
  onNext,
  onFirst,
  onLast,
  containerClassName,
  statusText,
}) => {
  const totalCountDiff = Math.max(from(page, pageSize) - totalCount, 0);
  const pageDiff = totalCountDiff && Math.ceil(totalCountDiff / pageSize);

  return (
    <div
      className={classNames(
        containerClassName,
        "mydpd-dndtable-pagination p-2"
      )}
    >
      <Button.Toolbar>
        <Button variant="dark" onClick={() => onFirst(1)} disabled={page <= 1}>
          First
        </Button>
        <Button
          variant="dark"
          onClick={() => onPrevious(page - 1 - pageDiff)}
          disabled={page <= 1}
        >
          Previous
        </Button>
      </Button.Toolbar>
      <div className={"mydpd-dndtable-pagination-counter"}>
        {`${statusText} ${from(page, pageSize) - totalCountDiff} - ${to(
          page,
          pageSize,
          totalCount
        )} of ${totalCount}`}
      </div>
      <Button.Toolbar className="justify-content-end">
        <Button
          variant="dark"
          onClick={() => onNext(page + 1 - pageDiff)}
          disabled={Math.ceil(totalCount / pageSize) <= page}
        >
          Next
        </Button>
        <Button
          variant="dark"
          onClick={() => onLast(Math.ceil(totalCount / pageSize))}
          disabled={Math.ceil(totalCount / pageSize) <= page}
        >
          Last
        </Button>
      </Button.Toolbar>
    </div>
  );
};

DndPaginator.from = from;
DndPaginator.to = to;

DndPaginator.defaultProps = {
  onNext: () => null,
  onPrevious: () => null,
  onFirst: () => null,
  onLast: () => null,
  statusText: "",
};

DndPaginator.propTypes = {
  page: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  onFirst: PropTypes.func,
  onLast: PropTypes.func,
  containerClassName: PropTypes.string,
  statusText: PropTypes.string,
};

export default withScrollReset(DndPaginator);
